import { Button, Chip, Divider, Drawer, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { rem, goShare } from "assets/js/common";
import { useForm } from "react-hook-form";
import Loading from "components/ui/loading";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  recommendItemDetail: {
    "& .head": {
      padding: rem(30),
      "& .tit": {
        fontSize: rem(18),
        fontWeight: 800,
        marginBottom: rem(6),
      },
      "& .MuiChip-root.MuiChip-filled": {
        backgroundColor: "transparent",
        color: theme.palette.info.main,
        letterSpacing: "-0.2px",
        padding: 0,
      },
    },
    "& .body": {
      "& img": {
        width: "100%",
        borderRadius: rem(10),
      },
      "& .cont": {
        padding: `${rem(30)} ${rem(30)} 0 ${rem(30)}`,
        fontSize: rem(15),
        wordBreak: "break-all",
        lineHeight: rem(25),
      },
    },
    "& .share": {
      position: "fixed",
      display: "block",
      width: rem(50),
      height: rem(50),
      right: rem(25),
      bottom: rem(25),
    },
  },
}));

export default function RecommendItemDetail() {
  let { seq } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [detailData, setDetailData] = useState([]);
  const [title, setTitle] = useState("");
  const [fetching, setFetching] = useState(false);
  const history = useHistory();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: title, menu: true }));
  }, [init]);

  useEffect(() => {
    setFetching(true);
    window.scrollTo(0, 0);
    loadTitle();
    loadDetail();
  }, []);

  window.appBackKeyHandle = () => {
    if (history.action == "POP") {
      //TEST
      history.replace("/");
    } else {
      history.goBack();
    }
  };

  const loadTitle = () => {
    axios.get(`/api/eh/recommend-product/get-title`).then((res) => {
      setTitle(res.data.data.title);
      dispatch(
        loadAction({ back: true, title: res.data.data.title, menu: false })
      );
    });
  };

  const handleTrustDetailClose = () => {
    setTrustDetail(false);
  };

  const loadDetail = () => {
    setValue("popperData", false);
    watch("popperData", false);
    axios
      .get(`/api/eh/recommend-product/get/${seq}`)
      .then((res) => {
        if (res.data.data.recommendProduct)
          setDetailData(res.data.data.recommendProduct);
        else history.replace("/notFound");
        setFetching(false);
      })
      .catch((error) => {
        history.replace("/notFound");
        setFetching(false);
      });
  };

  useEffect(() => {
    if (detailData.pstgEndYmd && detailData.pstgStrtYmd) {
      let today = moment(moment().format("YYYYMMDD"));
      if (
        moment(detailData.pstgEndYmd) < today ||
        today < moment(detailData.pstgStrtYmd)
      ) {
        history.push("/notFound");
      }
    }
  }, [detailData]);

  const [shareable, setShareable] = useState(false);
  const checkShareable = () => {
    if (!shareable) {
      setShareable(true);
      goShare("trust", seq);

      setTimeout(() => {
        setShareable(false);
      }, 1000);
    }
  };

  return (
    <>
      <Loading open={fetching} />
      <main id="main" className={"container " + classes.recommendItemDetail}>
        <div className="head">
          <div
            className="tit"
            dangerouslySetInnerHTML={{
              __html: detailData.ttl ? detailData.ttl : "-",
            }}
          />
          <Chip label={detailData.catg} />
        </div>
        <Divider />
        <div className="body">
          {/* <div
          className="lazy"
          style={{
            display: getValues("popperData") === false ? "block" : "none",
            width: "100%",
            height: rem(212),
            backgroundColor: "#CCCCCC",
          }}
        />
        <img
          src={detailData.imgUrl}
          onLoad={() => {
            setValue("popperData", true);
          }}
          style={{
            display: getValues("popperData") === true ? "" : "none",
          }}
        /> */}
          <div
            className="cont"
            dangerouslySetInnerHTML={{
              __html: detailData.cont ? detailData.cont : "-",
            }}
          />
        </div>
        <div className="share" onClick={checkShareable}>
          <img
            src={`${process.env.PUBLIC_URL}/images/icon/share.svg`}
            alt="공유하기"
          />
        </div>
      </main>
    </>
  );
}
